module.exports = __webpack_public_path__ + "img/trash-icon-25022022.dd6c9f62.svg";